import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import { DefaultService as api, PostCheckinTravelersRequest } from 'src/sdk_checkin';
import { CheckinBaseClass } from '../../components';
import {
  CheckinPassengerInputResultState,
  CheckinPassengerInputResultStore,
  resetCheckinPassengerInputResult,
  selectCheckinPassengerInputResultState,
  setCheckinPassengerInputResultFromApi,
} from '../../store';

@Injectable()
export class CheckinPassengerInputResultStoreService extends CheckinBaseClass {
  /** チェックイン搭乗者情報更新APIのレスポンス */
  private _checkinPassengerInputResult$ = this._checkinPassengerInputResultStore.pipe(
    select(selectCheckinPassengerInputResultState),
    pairwise(),
    filter(([prev, curr]) => prev.isPending === true && curr.isPending === false),
    map(([_, cur]) => cur)
  );

  /**
   * エラーが発生していないチェックイン搭乗者情報更新APIのレスポンス通知
   */
  get success$(): Observable<CheckinPassengerInputResultState> {
    return this._checkinPassengerInputResult$.pipe(filter((state) => state.isFailure === false));
  }

  /**
   * エラーが発生しているチェックイン搭乗者情報更新APIのレスポンス通知
   */
  get failure$(): Observable<CheckinPassengerInputResultState> {
    return this._checkinPassengerInputResult$.pipe(filter((state) => state.isFailure === true));
  }

  constructor(private _checkinPassengerInputResultStore: Store<CheckinPassengerInputResultStore>, private api: api) {
    super();
  }

  /**
   * 共通事後処理
   */
  override destroy(): void {
    this._checkinPassengerInputResultStore.dispatch(resetCheckinPassengerInputResult());
  }

  /**
   * チェックイン搭乗者情報更新APIを呼び出す
   * @param parameter チェックイン搭乗者情報更新APIのリクエストパラメータ
   */
  request(parameter: PostCheckinTravelersRequest): void {
    const call = this.api.journeysUpdateTravelersPost(parameter);
    this._checkinPassengerInputResultStore.dispatch(setCheckinPassengerInputResultFromApi({ call }));
  }
}
